export default "__VITE_ASSET__BypASh1j__"